<template>

<div class="container pt-3">

	<template v-if="authed">
		<h2>Company Form</h2>
		<h3 v-if="formRecord">{{formRecord.FormChildTemplate.description}} / {{formRecord.FormChildTemplate.FormTemplate.title}}</h3>

		<alert :visible="alert.visible" :unclosable="true" icon="fa-check" :message="alert.message" :class="alert.alertClass"></alert>

		<p>Please review the following information:</p>

		<form-fillable
			v-model="formSections" 
			:acknowledgements="acknowledgements"
			:form-is-active="formIsActive"
			:no-participant-controls="true"
			:readonly="true"
			:project="'Job' in formRecord && formRecord.Job ? formRecord.Job : false"
			:service="'Service' in formRecord && formRecord.Service ? formRecord.Service : false"
			v-on:submit="submitAcknowledgement">
		</form-fillable>

		<alert :visible="alert.visible" :unclosable="true" icon="fa-check" :message="alert.message" :class="alert.alertClass"></alert>
	</template>
	<div v-else-if="authFetched && !authed" class="text-center">
		
		<h2>This page authorization has expired</h2>
		<p>The security token needed to view this page has expired.</p>

	</div>
</div>

</template>
<script type="text/javascript">
import FormFillable from "@/components/company_forms/FormFillable"
import Alert from "@/components/Alert"

import FormMixins from "@/mixins/FormMixins.js"

export default {
	name: "ExternalFillableForm",
	components: {
		FormFillable,
		Alert
	},
	mixins: [FormMixins],
	data() {
		return {
			formRecord: null,
			formSections: [],
			acknowledgements: [],
			successAlertVisible: false,
			successMessage: "",
			newAcknowledgements: [],
			alertClass: "alert-success",
			alert: {
				alertClass: "alert-success",
				visible: false,
				message: ""
			},
			authFetched: false,
			authed: false,
			token: null
		}
	},
	computed: {
		formIsActive() {

			if (this.formRecord.expiry && this.moment(this.formRecord.expiry).isAfter(this.moment()) && this.formRecord.is_deactivated == 0)
				return true

			else (!this.formRecord.expiry && this.formRecord.is_deactivated == 0)
				return true

			return false

		}
	},
	methods: {
		submitAcknowledgement(form) {

			let vm = this

			let fields = ["id","form_id","user_id","is_external_worker","email","name","phone","company_name","signature_json","form_json","is_invite"]

			// Add in participants that are new, or just completed invitations
			this.newAcknowledgements = form.participants
				.filter(part => {
					return !('id' in part || 'slug' in part) ||
						('is_invite' in part && part.is_invite == 1 && 'signature_json' in part && part.signature_json)
				})
				.map(part => {
					part.form_id = vm.formRecord.id
					part.form_json = vm.formRecord.form_json
					part.is_invite = false

					let record = {}
					fields.forEach(key => {
						record[key] = part[key]
					})

					if ("acknowledgement_slug" in vm.$route.params) 
						//include the invite acknowledgement slug, so the api knows to mark the invite as completed
						record.inviteSlug = vm.$route.params.acknowledgement_slug

					return record
			})

			let ackBatchPayload = {
				records: JSON.stringify(this.newAcknowledgements)
			}

			if (this.token)
				ackBatchPayload.token = this.token

			if (this.newAcknowledgements.length > 0) {

				vm.postData("CompanyFormAcknowledgement/save-batch",ackBatchPayload,true).then(response => {
					if (response.success) {
						vm.alert.visible = true
						vm.alert.alertClass = "alert-success"
						vm.alert.message = "You have successfully signed the form! You may now close this page."

						/** Fetching form as external worker will delete signature
						vm.fetchForm()
						*/
					}
				})
			}
			else {
				vm.alertFail("Please sign the form first before submitting it!")
				vm.alert.visible = true
				vm.alert.alertClass = "alert-danger"
				vm.alert.message = "Please sign the form first before submitting it!"
			}
		},
		fetchForm() {
			let vm = this

			this.spinner(true)
			this.fetchCompanyForm(this.$route.params.slug,this.$route.params.token).then(response => {
				vm.spinner(false)
				vm.authFetched = true
				if (response.success) {
					vm.authed = true
					vm.formRecord = response.data

					try {
						vm.formSections = JSON.parse(response.data.form_json)
					}
					catch (e) {}

					vm.acknowledgements = response.data.CompanyFormAcknowledgement
				}
				else if ("errors" in response && response.errors.indexOf("Token or Api key not valid") >= 0)
					vm.authed = false
				else if ("errors" in response) {
					vm.alertErrors(response.errors)
				}

			})
		}
	},
	created() {
		this.$store.portalMode = true

		// We are an external user, and a token is provided? Use it
		if ('token' in this.$route.params && this.$route.params.token && !this.$store.sessionToken) {
			this.token = this.$route.params.token
			this.$set(this.$store, "sessionToken", this.$route.params.token)
			localStorage.apiKey = this.token
		}


		this.fetchForm()
	}
}
</script>